import { render, staticRenderFns } from "./DynamicAttributeOptions.vue?vue&type=template&id=24e3c3fd&"
import script from "./DynamicAttributeOptions.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports